import { Region } from "src/models/region";
import { api } from "./api";

export const getAllRegions = () => {
  return api.get<Region[]>("/regions");
};
